import { appSync, socketConnected, startListening } from '@betty/toolkit/state';
import { InboxMessageResponse } from './inbox.types';
import { addInboxMessage, fetchInbox } from './inbox.slice';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch }) => {
    dispatch(fetchInbox());
  },
});

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const socketConnection = action.payload;

    socketConnection.on(
      'InboxMessageReceived',
      (message: InboxMessageResponse) => {
        dispatch(addInboxMessage(message));
      },
    );
  },
});
